// sessionStorage key used to hand the main (space) booking's orderData/listing
// from ListingPage's submit handler over to CartPage — same mechanism
// CheckoutPage itself uses, just under its own key.
export const CART_STORAGE_KEY = 'CartPage';
